import React from 'react';
export function TermsConditions() {
  return <div className="space-y-6" data-id="element-145">
      <section data-id="element-146">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-147">
          1. Aceptación de los Términos
        </h3>
        <p className="leading-relaxed" data-id="element-148">
          Al acceder y comprar el "Protocolo Adiós Insomnio 3AM", usted acepta
          estar sujeto a estos Términos y Condiciones. Si no está de acuerdo con
          alguna parte de estos términos, no debe realizar la compra ni utilizar
          el producto.
        </p>
      </section>

      <section data-id="element-149">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-150">
          2. Naturaleza del Producto Digital
        </h3>
        <p className="leading-relaxed" data-id="element-151">
          El "Protocolo Adiós Insomnio 3AM" es un producto digital en formato
          PDF. Tras la confirmación del pago, recibirá acceso instantáneo para
          descargar el material. Debido a la naturaleza digital del producto,
          asegúrese de guardar una copia en un dispositivo seguro.
        </p>
      </section>

      <section data-id="element-152">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-153">
          3. Uso Permitido y Licencia
        </h3>
        <p className="leading-relaxed" data-id="element-154">
          La compra le otorga una licencia personal, no exclusiva y no
          transferible para acceder y utilizar el protocolo. Queda estrictamente
          prohibida la reventa, distribución, copia, modificación o uso
          comercial de cualquier parte del material. El contenido está protegido
          por leyes de derechos de autor y propiedad intelectual.
        </p>
      </section>

      <section data-id="element-155">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-156">
          4. Limitación de Responsabilidad Médica
        </h3>
        <p className="leading-relaxed" data-id="element-157">
          El contenido proporcionado en este protocolo tiene fines estrictamente
          educativos e informativos.{' '}
          <strong data-id="element-158">
            No constituye consejo médico, diagnóstico ni tratamiento
            profesional.
          </strong>{' '}
          Las técnicas descritas, incluyendo los cambios de temperatura y
          ejercicios de respiración, deben practicarse con precaución. Si padece
          condiciones médicas preexistentes, problemas cardiovasculares,
          respiratorios o trastornos graves del sueño (como apnea obstructiva),
          debe consultar a un profesional de la salud antes de aplicar este
          protocolo.
        </p>
      </section>

      <section data-id="element-159">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-160">
          5. Garantía de Satisfacción
        </h3>
        <p className="leading-relaxed" data-id="element-161">
          Ofrecemos una garantía de satisfacción. Si ha aplicado
          consistentemente el protocolo durante el período de prueba indicado en
          la oferta y no experimenta mejoras en su latencia de sueño, puede
          solicitar un reembolso completo contactando a nuestro soporte dentro
          del plazo establecido desde la fecha de compra.
        </p>
      </section>

      <section data-id="element-162">
        <h3 className="text-xl font-bold text-white mb-3" data-id="element-163">6. Modificaciones</h3>
        <p className="leading-relaxed" data-id="element-164">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios entrarán en vigor inmediatamente después de su
          publicación en el sitio web. Su uso continuado del producto después de
          cualquier modificación constituye su aceptación de los nuevos
          términos.
        </p>
      </section>

      <p className="text-sm text-slate-400 mt-8 pt-4 border-t border-slate-700" data-id="element-165">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        month: 'long',
        year: 'numeric'
      })}
      </p>
    </div>;
}